import { jsx as _jsx } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgCheckCircleFilled = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    id: "icon",
    d: "M7.99967 1.33325C4.31967 1.33325 1.33301 4.31992 1.33301 7.99992C1.33301 11.6799 4.31967 14.6666 7.99967 14.6666C11.6797 14.6666 14.6663 11.6799 14.6663 7.99992C14.6663 4.31992 11.6797 1.33325 7.99967 1.33325ZM6.66634 11.6066L3.52634 8.46659L4.46634 7.52659L6.65967 9.71992L11.5197 4.85992L12.4597 5.79992L6.65301 11.6066H6.66634Z",
    fill: "#1B1918"
  })
});
export default SvgCheckCircleFilled;